import type { AxiosResponse } from 'axios';
import { http } from '@/api/Connect';
import { buildUrl } from '@/helpers/buildUrl';

import type {
  UserActiveHoldsRequestParams,
  UserActiveHoldsResponse,
  UserHoldsHistoryRequestParams,
  UserHoldsHistoryResponse
} from '@/api/schema';

export const getUserActiveHolds = (
  operatorUserId: string,
  params: UserActiveHoldsRequestParams
): Promise<UserActiveHoldsResponse> => {
  return http
    .get(buildUrl(`/api/v1/{operatorId}/user/${operatorUserId}/holds-active`), {
      params
    })
    .then(({ data }: AxiosResponse<UserActiveHoldsResponse>) => data);
};

export const getUserHoldsHistory = (
  operatorUserId: string,
  params: UserHoldsHistoryRequestParams
): Promise<UserHoldsHistoryResponse> => {
  return http
    .get(
      buildUrl(`/api/v1/{operatorId}/user/${operatorUserId}/holds-history`),
      {
        params
      }
    )
    .then(({ data }: AxiosResponse<UserHoldsHistoryResponse>) => data);
};
